import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, getAnonId } from "@/lib/api";

/**
 * AuthCallback — handles the URL fragment `#session_id=...` returned by Emergent Auth.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    const anonId = localStorage.getItem("balagha_uid") || getAnonId();

    (async () => {
      try {
        await api.exchangeSession(session_id, anonId);
        // Clear the anon UID so subsequent requests use the authed cookie identity
        localStorage.removeItem("balagha_uid");
        // Clean hash and reload to /
        window.location.replace("/");
      } catch (e) {
        console.error("auth callback failed", e);
        navigate("/login?err=1", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="shell" style={{ textAlign: "center", paddingTop: 120 }}>
      <div className="muted">يجري إكمال تسجيل الدخول...</div>
    </div>
  );
}
